import { renderNav } from './nav';
import { renderFooter } from './footer';
//import { isAuthenticated } from '../services/auth';

export function renderLayout(content: string): void {

    //const isUserAuthenticated = isAuthenticated();
    //<div> authed: ${isUserAuthenticated}</div>
    const app = document.getElementById('app') as HTMLElement;
    app.innerHTML = `
    
    <header id="nav">
    </header>
    
    <main id="app-content">
      <div class="content" id="page-content">${content}</div>
      <!-- Dynamic content loaded by JavaScript (e.g., login, dashboard, wizard) -->
      
      <div id="step-container" class="step-container">
        <!-- Wizard steps or dashboard list will be injected here -->
      </div>
    </main>
    
    <footer id="footer" class="footer"></footer>
  `;

    renderNav(document.getElementById('nav') as HTMLElement);
    renderFooter(document.getElementById('footer') as HTMLElement);
}

/*
<div id="progress-bar" class="progress-bar">
        <div id="progress" class="progress"></div>
      </div>
      */